export namespace MainPage {
  export enum Pages {
    MAIN ='home',
    MAIN_ALERT ='main_page',
  }
}
